import { AnimatePresence } from 'framer-motion'
import { MOTION } from 'styles/consts'
import * as Styled from './styled'
import { IBaseDropdownItem, IDropdownMainContentProps } from '../types'
import React from 'react'
import SearchNoResult from 'common-components/SearchNoResult'

const ANIMATION_PROPERTIES = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: MOTION.duration.base, ease: MOTION.ease.out }
}

export const DropdownMainContent = <T extends IBaseDropdownItem>({
  onListItemClick,
  data,
  activeItem,
  ChildComponent,
  searchQuery,
  noResultsImage
}: IDropdownMainContentProps<T>) => {
  if (data.length === 0 && searchQuery) {
    return (
      <Styled.DropdownListWrapper>
        <SearchNoResult searchValue={searchQuery} imgSrc={noResultsImage} />
      </Styled.DropdownListWrapper>
    )
  }
  return (
    <Styled.DropdownListWrapper>
      <AnimatePresence>
        <Styled.ListWrapper {...ANIMATION_PROPERTIES} key="list-wrapper">
          {data.map((item: T) => {
            return (
              <React.Fragment key={`${item.id}`}>
                <ChildComponent
                  key={`${item.id}`}
                  item={item}
                  isActive={item.id === activeItem?.id}
                  onClick={() => onListItemClick(item.id)}
                />
              </React.Fragment>
            )
          })}
        </Styled.ListWrapper>
      </AnimatePresence>
    </Styled.DropdownListWrapper>
  )
}
